import { findKey, filter } from 'lodash';

export default [() => {
    const restructure = (input, flatten = null) => {
        for(let i = 0; i < input.length; i++){
            if (!('children' in input[i])){
                input[i].children = [];
            }
            if (parseInt(input[i].parent, 10) > 0){
                let parent = input[findKey(input, {'id': parseInt(input[i].parent, 10)})];
                if (parent){
                    if (!('children' in parent)){
                        parent.children = [
                            input[i]
                        ];
                    }else{
                        parent.children.push(input[i]);
                    }
                }
            }
        }

        let result = filter(input, item => !item.parent);

        let collection = [];

        if (flatten){
            function extract(arr){
                for (let i = 0; i<arr.length; i++){
                    collection.push(arr[i]);
                    if (arr[i].level) arr[i].name = '-'.repeat(arr[i].level)+' '+arr[i].name;
                    extract(arr[i].children);
                }
            }
            extract(result);
        }

        return {
            'total': 0,
            'per_page': 20,
            'current_page': 1,
            'data': input,
            'tree': result,
            'flat': collection
        };
    };

    return {
        restructure
    };
}];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/services/categories.transformer.service.js